const TRANSACTION_TYPES = {
    PUBLIC_APPEARANCE: 1,
    SOCIAL_MEDIA: 2,
    CAMPS_AND_LESSONS: 3,
    AUTOGRAPHS: 4,
    BUSINESS_OWNERSHIP_CREATION: 5,
    OUTSIDE_EMPLOYMENT: 6,
    REPRESENTATION_DISCLOSURE: 7,
    OTHER: 8,
    ROYALTY: 9,
    NOT_SURE: 10,
    COLLECTIVE: 11,
    EVENT_EXPERIENCE: 12,
    EARNED_MEDIA: 13,
    ENTERTAINMENT: 14,
    INFLUENCER: 15,
    IN_MARKET_APPEARANCE: 16,
    NASCAR_CONTENT: 17,
    FOUNDATION_HOF: 18,
    INDUSTRY_EVENT: 19,
    BROADCAST: 20,
    PARTNERSHIP: 21,
    IMPACT: 22,
    BRAND: 23,
    DRIVER_SUBMISSION: 24,
};
const LEADERBOARD_ONLY_TRANSACTION_TYPE_IDS = [2, 8, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24];
const NON_LEADERBOARD_TRANSACTION_TYPE_IDS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
const EXCHANGE_STATUSES = {
    PROPOSED: 0,
    DECLINED: 1,
    APPROVED: 2,
    EXPIRED: 3,
    QUEUED: 4,
    PAYMENT_QUEUE_FAILED: 5,
    PAYMENT_PROCESSING: 30,
    PAYMENT_FAILED: 40,
    PAYMENT_COMPLETED: 50,
    PAYMENT_ON_HOLD: 60,
    TRANSFER_PROCESSING: 70,
    TRANSFER_FAILED: 80,
    TRANSFER_COMPLETE: 90,
    PAYOUT_PENDING: 100,
    PAYOUT_PROCESSING: 110,
    PAYOUT_FAILED: 120,
    PAYOUT_COMPLETED: 130,
    PAID_OUTSIDE_INFLCR: 140,
};
const LEADERBOARD_STATUSES = {
    NOT_READY_FOR_REVIEW: 0,
    READY_FOR_REVIEW: 1,
    APPROVED: 2,
    REJECTED: 3,
};
const TRANSACTION_UNIT_TYPES = {
    US_DOLLARS: 0,
    POINTS: 1,
};
const TRANSACTION_TASK_STATUSES = {
    INCOMPLETE: 0,
    COMPLETE: 255,
};
const TRANSACTION_PAYMENT_FEES = {
    ACH_PERCENTAGE_FEE: 0,
    CARD_FLAT_FEE: 1,
    CARD_PERCENTAGE_FEE: 2,
    PAYOUT_FLAT_FEE: 3,
    PAYOUT_INSTANT_PERCENTAGE_FEE: 4,
    PAYOUT_PERCENTAGE_FEE: 5,
};
const PAYABLE_STATUSES = {
    CAN_PAY: 0,
    UNRESOLVED_TASKS: 1,
    AWAITING_SCHOOL: 2,
    AWAITING_ATHLETE: 3,
    ATHLETE_DECLINED: 4,
    ALREADY_PAID: 5,
    PAID_OUTSIDE_INFLCR: 6,
    NOT_PAYABLE: 7,
    EXPIRED: 8,
};
const TRANSACTION_STATUSES = {
    PROPOSED: -1,
    SUBMITTED: 0,
    UPDATED: 1,
    FLAGGED: 2,
    APPROVED: 3,
    IN_REVIEW: 4,
    REVIEWED: 5,
};
const TRANSACTION_REPORTING_METHODS = {
    SELF: 0,
    EXTERNAL: 1,
    THIRD_PARTY: 2,
    MPORT: 3,
    LOCAL_EXCHANGE: 4,
    GLOBAL_EXCHANGE: 5,
};
const TRANSACTION_PAYMENT_TYPES = {
    CASH: 0,
    "PRODUCT/EQUITY": 1,
    POINTS: 2,
};
export { EXCHANGE_STATUSES, LEADERBOARD_STATUSES, PAYABLE_STATUSES, TRANSACTION_PAYMENT_FEES, TRANSACTION_PAYMENT_TYPES, TRANSACTION_REPORTING_METHODS, TRANSACTION_STATUSES, TRANSACTION_TASK_STATUSES, TRANSACTION_TYPES, TRANSACTION_UNIT_TYPES, LEADERBOARD_ONLY_TRANSACTION_TYPE_IDS, NON_LEADERBOARD_TRANSACTION_TYPE_IDS, };
